import React from 'react';
import { Calendar } from 'lucide-react';
import { UnavailableDataBadge } from './UnavailableDataBadge';

interface TimelineProps {
  dates: {
    opening: string | null;
    start: string | null;
    completion: string | null;
  };
  isEnglish?: boolean;
}

export const Timeline: React.FC<TimelineProps> = ({ dates, isEnglish }) => {
  const hasAnyDate = dates.opening || dates.start || dates.completion;

  if (!hasAnyDate) {
    return <UnavailableDataBadge />;
  }

  return (
    <div className="bg-gray-50 rounded-lg p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center md:space-x-8 space-y-6 md:space-y-0">
        {dates.opening && (
          <div className="flex items-center md:flex-1">
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-full flex items-center justify-center">
              <div className="w-3 h-3 bg-blue-500 rounded-full" />
            </div>
            <div className="ml-3 md:ml-4 flex-grow">
              <div className="flex items-center text-sm text-gray-500">
                <Calendar className="w-4 h-4 mr-1" />
                <span>{isEnglish ? 'Opening' : 'Abertura'}</span>
              </div>
              <p className="text-gray-700 font-medium mt-1 text-sm md:text-base">{dates.opening}</p>
            </div>
            {dates.start && (
              <div className="hidden md:block flex-1 h-0.5 bg-gray-200 mx-4" />
            )}
          </div>
        )}

        {dates.start && (
          <div className="flex items-center md:flex-1">
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-green-100 rounded-full flex items-center justify-center">
              <div className="w-3 h-3 bg-green-500 rounded-full" />
            </div>
            <div className="ml-3 md:ml-4 flex-grow">
              <div className="flex items-center text-sm text-gray-500">
                <Calendar className="w-4 h-4 mr-1" />
                <span>{isEnglish ? 'Start' : 'Início'}</span>
              </div>
              <p className="text-gray-700 font-medium mt-1 text-sm md:text-base">{dates.start}</p>
            </div>
            {dates.completion && (
              <div className="hidden md:block flex-1 h-0.5 bg-gray-200 mx-4" />
            )}
          </div>
        )}

        {dates.completion && (
          <div className="flex items-center md:flex-1">
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-purple-100 rounded-full flex items-center justify-center">
              <div className="w-3 h-3 bg-purple-500 rounded-full" />
            </div>
            <div className="ml-3 md:ml-4 flex-grow">
              <div className="flex items-center text-sm text-gray-500">
                <Calendar className="w-4 h-4 mr-1" />
                <span>{isEnglish ? 'Completion' : 'Conclusão'}</span>
              </div>
              <p className="text-gray-700 font-medium mt-1 text-sm md:text-base">{dates.completion}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};